export const updateLocation = location => ({
    type: 'UPDATE_LOCATION',
    payload: location,
})